import { useEffect, useRef } from "react";

const INTERACTIVE = "a, button, [role='button'], [role='tab'], [role='option'], [role='switch'], [role='checkbox'], label, select";

// A soft ring that trails the pointer, grows over clickable things and squeezes on click.
export default function PlayfulCursor() {
  const ring = useRef(null);
  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;
    const target = { x: -100, y: -100 };
    const pos = { x: -100, y: -100 };
    let frame;
    const tick = () => {
      pos.x += (target.x - pos.x) * 0.25;
      pos.y += (target.y - pos.y) * 0.25;
      if (ring.current) ring.current.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      // stop the loop once settled so an idle page costs nothing
      frame = Math.abs(target.x - pos.x) + Math.abs(target.y - pos.y) > 0.5 ? requestAnimationFrame(tick) : null;
    };
    const move = (e) => {
      target.x = e.clientX;
      target.y = e.clientY;
      ring.current?.classList.toggle("is-hover", !!e.target.closest?.(INTERACTIVE));
      if (!frame) frame = requestAnimationFrame(tick);
    };
    const down = () => ring.current?.classList.add("is-down");
    const up = () => ring.current?.classList.remove("is-down");
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mousedown", down);
    window.addEventListener("mouseup", up);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mousedown", down);
      window.removeEventListener("mouseup", up);
    };
  }, []);
  return <div ref={ring} className="cursor-trail hidden md:block" aria-hidden="true" />;
}
